import type { IUser } from '@tambola/shared';
import { apiClient } from '../api/client.js';

/**
 * REST API client authentication service.
 */
export const authService = {
  /**
   * Log in as guest with a display name.
   */
  async loginAsGuest(displayName: string): Promise<IUser> {
    const res = await apiClient.post('/auth/guest', { displayName });
    return res.data.data;
  },

  /**
   * Log in using Google credentials token.
   */
  async loginWithGoogle(token: string): Promise<IUser> {
    const res = await apiClient.post('/auth/google', { token });
    return res.data.data;
  },

  /**
   * Fetch current authenticated user session details.
   */
  async getCurrentUser(): Promise<IUser> {
    const res = await apiClient.get('/auth/me');
    return res.data.data;
  },

  /**
   * Clear current user token session.
   */
  async logout(): Promise<void> {
    await apiClient.post('/auth/logout');
  },
};
export default authService;
